// extracted by mini-css-extract-plugin
export default {"message":"Message_message__UdveK","success":"Message_success__KxHb2","error":"Message_error__yFZBo"};